module.exports = __webpack_public_path__ + "img/map-pin-generic.14d31de1.svg";